var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBitcoin = function SvgBitcoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 98 98"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.476 18.879H14.109v-4h47.367c7.503 0 17.245 6.754 17.245 18.333 0 11.67-9.84 17.79-17.245 17.79H30.987v-4h30.489c5.662 0 13.245-4.77 13.245-13.79 0-9.109-7.68-14.333-13.245-14.333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.92 79.121H14.11v4h52.81c7.503 0 17.245-6.754 17.245-18.333 0-11.67-9.84-17.79-17.245-17.79H30.988v4h35.934c5.662 0 13.244 4.77 13.244 13.79 0 9.109-7.68 14.333-13.245 14.333Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.531 82.212V16.88h4v65.333h-4ZM34.977 16.333V0h4v16.333h-4ZM34.977 98.001V81.668h4v16.333h-4ZM58.938 16.333V0h4v16.333h-4ZM58.938 98.001V81.668h4v16.333h-4Z"
  })));
};
export default SvgBitcoin;